import type { AssetAttributes, AssetFieldDefinition } from '@/types/oscar';

/**
 * Helpers for the per-category custom Attributes bag (oscar.AssetFieldDefinition).
 * Kept separate from the {@link AssetAttributeFields} component so the component
 * file only exports a component (React Fast Refresh).
 */

/** Coerce a raw form string to the value type the API expects per DataType. */
export function coerce(def: AssetFieldDefinition, raw: string): string | number | boolean | null {
  if (raw === '') return null;
  if (def.DataType === 'Number') { const n = Number(raw); return Number.isNaN(n) ? raw : n; }
  if (def.DataType === 'Boolean') return raw === 'true';
  return raw;
}

/** Build the typed Attributes bag from raw string values, dropping blanks. */
export function buildAttributes(defs: AssetFieldDefinition[], values: Record<string, string>): AssetAttributes {
  const attributes: AssetAttributes = {};
  for (const def of defs) {
    const raw = values[def.FieldKey];
    if (raw !== undefined && raw !== '') attributes[def.FieldKey] = coerce(def, raw);
  }
  return attributes;
}

/** The required definitions that are still blank. */
export function missingRequired(defs: AssetFieldDefinition[], values: Record<string, string>): AssetFieldDefinition[] {
  return defs.filter((d) => d.IsRequired && !(values[d.FieldKey] ?? '').trim());
}
